"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Main = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Container = require("../Container");

var _Grid = require("../Grid");

var _LinkGroup = require("../LinkGroup");

var _AppLinksContainer = require("../AppLinksContainer");

var _ImageMain = require("../ImageMain");

var _styles = require("./styles");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  groupList: (0, _propTypes.arrayOf)((0, _propTypes.arrayOf)((0, _propTypes.shape)({
    title: _propTypes.string,
    links: _propTypes.array
  }))),
  'data-testid': _propTypes.string
} : {};

var Main = function Main(_ref) {
  var groupList = _ref.groupList,
      dataTestId = _ref['data-testid'];
  return (0, _core.jsx)(_styles.Wrapper, {
    "data-testid": dataTestId
  }, (0, _core.jsx)(_Container.Container, null, (0, _core.jsx)(_Grid.Grid, {
    templateAreas: _styles.mainTemplateAreas
  }, (0, _core.jsx)(_Grid.GridItem, {
    area: "mainLinks"
  }, (0, _core.jsx)(_Grid.Grid, {
    templateColumns: _styles.mainLinksTemplateColumns
  }, (groupList == null ? void 0 : groupList.map) && groupList.map(function (group, groupListIndex) {
    return (0, _core.jsx)("div", {
      key: "LinkItem-".concat(groupListIndex)
    }, (group == null ? void 0 : group.map) && group.map(function (linkList, grouIndex) {
      return (0, _core.jsx)(_LinkGroup.LinkGroup, {
        id: "LinkGroup-".concat(linkList == null ? void 0 : linkList.title, "-").concat(grouIndex),
        key: "LinkGroup-".concat(grouIndex),
        title: linkList == null ? void 0 : linkList.title,
        links: linkList == null ? void 0 : linkList.links
      });
    }));
  }))), (0, _core.jsx)(_Grid.GridItem, {
    area: "image"
  }, (0, _core.jsx)(_ImageMain.ImageMain, null)), (0, _core.jsx)(_Grid.GridItem, {
    area: "appLinksContainer"
  }, (0, _core.jsx)(_AppLinksContainer.AppLinksContainer, null)))));
};

exports.Main = Main;
process.env.NODE_ENV !== "production" ? Main.propTypes = propTypes : void 0;
Main.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Main",
  "props": {
    "groupList": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {
              "title": {
                "name": "string",
                "required": false
              },
              "links": {
                "name": "array",
                "required": false
              }
            }
          }
        }
      },
      "required": false,
      "description": ""
    },
    "data-testid": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};